export default __webpack_public_path__ + "static/avatar-fc2f7846ab29abd5485da77aff0fa88d.webp";